import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import type { JSONSchemaNode, SEO } from '@/lib/api/types';
import { SCHEMA_DEFS } from '@/config/collections';
import { SchemaForm } from '@/lib/forms/SchemaForm';

export const EMPTY_SEO: SEO = {
  meta_title: { en: '', ar: '' },
  meta_description: { en: '', ar: '' },
  og_image_id: null,
  canonical_url: '',
  no_index: false,
  keywords: { en: '', ar: '' },
};

/** SEO schema, rendered through the same schema-driven engine as blocks/doc (spec §9). */
function buildSeoSchema(t: TFunction): JSONSchemaNode {
  return {
    type: 'object',
    $defs: SCHEMA_DEFS,
    properties: {
      meta_title: { $ref: '#/$defs/I18n', title: t('seo.metaTitle') },
      meta_description: { $ref: '#/$defs/I18nRich', title: t('seo.metaDescription') },
      keywords: { $ref: '#/$defs/I18n', title: t('seo.keywords') },
      og_image_id: { type: 'string', format: 'uuid', title: t('seo.socialImage') },
      canonical_url: { type: 'string', title: t('seo.canonicalUrl') },
      no_index: { type: 'boolean', title: t('seo.noIndex') },
    },
  };
}

export function SeoPanel({
  value,
  onChange,
  translateOnly,
  disabled,
}: {
  value: SEO;
  onChange: (v: SEO) => void;
  translateOnly?: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <SchemaForm
      schema={buildSeoSchema(t)}
      value={value as unknown as Record<string, unknown>}
      onChange={(v) => onChange(v as unknown as SEO)}
      translateOnly={translateOnly}
      disabled={disabled}
    />
  );
}
